import { useCallback } from 'react';

type UserData = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  clientId: number;
};

type ReturnType = {
  updateUserData: (isAuthenticated: boolean, userData?: UserData) => void;
  extendEmbeddedData: (props: { [key: string]: any }) => void;
};

export const useFeedback = (): ReturnType => {
  const getClientData = () =>
    window['data'] ? JSON.parse(window['data']) : { clientname: 'GfK Support team', clientemail: 'asknewron@gfk.com' };

  const initXMDirectoryConfig = useCallback((userId: string) => {
    if (typeof (window as any).QSI === 'undefined') {
      (window as any).QSI = {
        config: {
          externalReference: userId,
        },
      };
    } else {
      (window as any).QSI.config = {
        ...(window as any).QSI.config,
        externalReference: userId,
      };
    }
  }, []);

  const reload = useCallback(() => {
    window.removeEventListener('qsi_js_loaded', reload);
    const QSI = (window as any).QSI;
    if (QSI?.API) {
      QSI.API.unload();
      QSI.API.load().then(QSI.API.run);
    } else {
      window.addEventListener('qsi_js_loaded', reload, false);
    }
  }, []);

  const extendEmbeddedData = useCallback(
    (data: { [key: string]: any }) => {
      const clientData = getClientData();
      window['data'] = JSON.stringify({
        ...clientData,
        ...data,
      });
      reload();
    },
    [reload]
  );

  const updateUserData = useCallback(
    async (isAuthenticated, userData?: UserData) => {
      const clientData = getClientData();
      const data =
        isAuthenticated && userData
          ? {
              company: userData.clientId,
              userid: userData.id,
              email: userData.email,
              firstname: userData.firstName,
              lastname: userData.lastName,
            }
          : {};

      window['data'] = JSON.stringify({
        ...clientData,
        ...data,
      });

      if (isAuthenticated && userData?.id) {
        initXMDirectoryConfig(userData.id);
      }
      reload();
    },
    [reload, initXMDirectoryConfig]
  );

  return {
    updateUserData,
    extendEmbeddedData,
  };
};
